<template>
  <section class="my-3">
    <v-form v-on:submit.prevent="doSearch" v-model="filtersInputs.validFilters">
      <v-row>
        <v-col cols="12" class="py-6">
          <AdvancedSearchComponent :loading="loading">
            <template v-slot:basic-search>
              <v-text-field
                id="coursesFilters-txt-courseName"
                v-model.trim="filtersInputs.courseName"
                :rules="rules.courseName"
                :label="$t('labels.courseName')"
                variant="outlined"
                clearable
              />
            </template>
            <template v-slot:advanced-search>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  id="coursesFilters-txt-studyPlan"
                  v-model.trim="filtersInputs.stdPlan"
                  :rules="rules.stdPlan"
                  :label="$t('labels.studyPlan')"
                  variant="outlined"
                  clearable
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  id="coursesFilters-txt-IHId"
                  v-model.trim="filtersInputs.IHId"
                  :rules="rules.IHId"
                  :label="$t('labels.IHId')"
                  variant="outlined"
                  clearable
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-select
                  id="coursesFilters-select-courseType"
                  :items="filters.courseTypes"
                  item-title="baName"
                  item-value="baID"
                  :loading="loading"
                  :disabled="loading"
                  :model-value="filtersInputs.courseType || null"
                  @update:model-value="filtersInputs.courseType = $event"
                  :label="$t('labels.courseType')"
                  variant="outlined"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4" v-if="filters.activeStatus">
                <v-select
                  id="coursesFilters-select-activeStatus"
                  :items="filters.activeStatus"
                  item-value="id"
                  item-title="name"
                  :loading="loading"
                  :disabled="loading"
                  :model-value="filtersInputs.activeStatus || null"
                  @update:model-value="filtersInputs.activeStatus = $event"
                  :label="$t('labels.status')"
                  variant="outlined"
                />
              </v-col>
            </template>
          </AdvancedSearchComponent>

          <input type="submit" hidden>
        </v-col>
      </v-row>
    </v-form>
  </section>
</template>

<script lang='ts'>
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, PropType } from 'vue';
import { CourseTypes } from '@/types/course.type';
import { FiltersInputs } from '@/types/questions.type';
import AdvancedSearchComponent from '@/shared/advancedSearch.component.vue';

export default defineComponent({
  name: 'CoursesListFiltersComponent',
  components: {
    AdvancedSearchComponent,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    filtersData: {
      type: Object as PropType<any>,
      required: true,
    },
    value: {
      type: Object as PropType<FiltersInputs>,
      required: true,
    },
  },
  data() {
    return {
      rules: {
        courseName: [
          (val: string) => val.trim().length <= 100
            || this.$t('validations.maxLength', { max: 100 }),
        ],
        stdPlan: [
          (val: string) => val.trim().length <= 100
            || this.$t('validations.maxLength', { max: 100 }),
        ],
        IHId: [
          (val: string) => val.trim().length <= 100
            || this.$t('validations.maxLength', { max: 100 }),
        ],
      },
    };
  },
  computed: {
    filtersInputs: {
      get(): any {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    filters(): any {
      return {
        ...this.filtersData,
        courseTypes: this.filtersData.courseTypes.map((type: CourseTypes) => ({
          ...type,
          baName: this.$utils.servertranslate(type.baName),
        })),
        activeStatus: this.filtersData.activeStatus?.map((status: any) => ({
          ...status,
          name: this.$t(`labels.${status.name}`),
        })),
      };
    },
  },
  methods: {
    doSearch() {
      if (this.filtersInputs.validFilters) {
        this.$emit('search');
      }
    },
  },
});
</script>
